import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchPayments, removePayment } from '../redux/slices/paymentSlice';
import '../styles/TableStyles.css';

function PaymentList() {
  const dispatch = useDispatch();
  const { payments, loading, error } = useSelector((state) => state.payments);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  React.useEffect(() => {
    dispatch(fetchPayments());
  }, [dispatch]);

  const handleDelete = (id) => {
    if (window.confirm('Are you sure you want to delete this payment record?')) {
      dispatch(removePayment(id));
    }
  };

  // Calculate pagination
  const totalPages = Math.ceil(payments.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const paginatedPayments = payments.slice(startIndex, endIndex);

  const handleNextPage = (e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePrevPage = (e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  if (loading) return <div className="loading">Loading...</div>;
  if (error) return <div className="error">Error: {error}</div>;

  return (
    <div className="table-container">
      <h2>Payment Records</h2>
      {payments.length === 0 ? (
        <p className="no-data">No payment records found</p>
      ) : (
        <>
          {/* Top Pagination Controls */}
          <div className="pagination-controls">
            <button 
              onClick={handlePrevPage} 
              disabled={currentPage === 1}
              className="pagination-btn"
              type="button"
              title="Previous page"
            >
              &lt;
            </button>
            <span className="pagination-info">
              {currentPage}/{totalPages}
            </span>
            <button 
              onClick={handleNextPage} 
              disabled={currentPage >= totalPages}
              className="pagination-btn"
              type="button"
              title="Next page"
            >
              &gt;
            </button>
          </div>

          <table className="modern-table">
            <thead>
              <tr>
                <th>Doctor</th>
                <th>Plan Name</th>
                <th>Amount (₹)</th>
                <th>Payment Date</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {paginatedPayments.map((payment) => (
                <tr key={payment.payment_id}>
                  <td>{payment.doctor_first_name} {payment.doctor_last_name}</td>
                  <td>{payment.plan_name}</td>
                  <td>₹{parseFloat(payment.amount).toFixed(2)}</td>
                  <td>{new Date(payment.payment_date).toLocaleDateString()}</td>
                  <td>
                    <button
                      className="delete-btn"
                      onClick={() => handleDelete(payment.payment_id)}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {/* Bottom Pagination Controls */}
          <div className="pagination-controls">
            <button 
              onClick={handlePrevPage} 
              disabled={currentPage === 1}
              className="pagination-btn"
              type="button"
              title="Previous page"
            >
              &lt;
            </button>
            <span className="pagination-info">
              {currentPage}/{totalPages}
            </span>
            <button 
              onClick={handleNextPage} 
              disabled={currentPage >= totalPages}
              className="pagination-btn"
              type="button"
              title="Next page"
            >
              &gt;
            </button>
          </div>
        </>
      )}
    </div>
  );
}

export default PaymentList;
